import React, { Component } from 'react';

import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styles from './JobOfferArticle.module.scss';

import Article from 'common/components/Article/Article';
import ArticleContent from '../ArticleContent/ArticleContent';
import ListWithImages from '../ListWithImages/ListWithImages';

@injectIntl
@withRouter
export default class JobOfferArticle extends Component {
  static defaultProps = {
    className: ''
  };

  render() {
    const { className, benefitsTitle, benefitsIntro } = this.props;

    return (
      <div className={`${styles.JobOfferArticle}  ${className}`}>
        <Article>
          <ArticleContent>
            <h3>{benefitsTitle}</h3>
            <p>{benefitsIntro}</p>
            <ListWithImages />
          </ArticleContent>
        </Article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/JobOffers/components/Article/JobOfferArticle/JobOfferArticle.js